import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cc4a83e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2cc4a83e&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4a83e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc4a83e')) {
      api.createRecord('2cc4a83e', component.options)
    } else {
      api.reload('2cc4a83e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cc4a83e&scoped=true", function () {
      api.rerender('2cc4a83e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/index.vue"
export default component.exports